import { useEffect, useState } from "react";

export const useGetRoles = () => {

    const [roles, setRoles] = useState([]);
    
    useEffect(() => {
        let unsubscribed = true;

        const getRoles = async () => {
            try {
                const response = await fetch(`/api/roles`);
                const { total, data } = await response.json();

                !total ? alert('Error inesperado, intentelo de nuevo') : setRoles(data);
            } catch (error) {
                throw new Error('Error inesperado, intentelo de nuevo');
            }
        }

        unsubscribed && getRoles();

        return () => unsubscribed = false;
    }, []);
    
    return {
        roles
    }
};